import { render } from "./AdminDashboard.vue?vue&type=template&id=b9b9deaa"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script